<template>
    <div class="manage--left" ref="lesson-left">
        <div class="div-list-lessons">
            <div class="nqt--list--lessons list--lessons--default" :class="[{active: activeID=='1cs'}]" v-on:click="changeItem({type: 1, dataChild: {id: '1cs', name: 'Khoá học mới nhất', order: null}})">
                <p class="title-lesson title_lesson_dad">
                    {{ $t("new.title130") }}
                </p>
            </div>
            <div class="nqt--list--lessons list--lessons--default" :class="[{active: activeID=='2cs'}]" v-on:click="changeItem({type: 2, dataChild: {id: '2cs', name: 'Khoá học đề xuất', order: null}})">
                <p class="title-lesson title_lesson_dad">
                    {{ $t("new.title131") }}
                </p>
            </div>
            <div class="nqt--list--lessons list--lessons--default" :class="[{active: activeID=='3cs'}]" v-on:click="changeItem({type: 3, dataChild: {id: '3cs', name: 'Khuyến khích bởi Study-Arts', order: null}})">
                <p class="title-lesson title_lesson_dad">
                    {{ $t("new.title132") }}
                </p>
            </div>
            <div class="nqt--list--lessons list--lessons--default" :class="[{active: activeID=='0cs'}]" v-on:click="changeItem({type: 0, dataChild: {id: '0cs', name: 'Tất cả danh mục', order: null}})">
               <p class="title-lesson title_lesson_dad">
                    {{ $t("new.title221") }}
               </p>
            </div>
            <div class="nqt--list--lessons list--lessons--default" @click="checkToogle()">
                <p class="title-lesson title_lesson_dad">
                    {{ $t("new.title133") }} <span v-if="toogle">&#9206;</span><span v-else>&#9207;</span>
                </p>
            </div>
            <template v-if="toogle">
                <ul class="nqt--list--lessons" v-for="(item, index) in listCatalog" :key="index" >
                    <li class="list-parentId" v-if="item.parentId == '0'" >

                        <p id="btn" class="title-lesson title_lesson_chid" 
                            :class="[{active: activeID==item.catalogId}]" 
                            @click.self="hamDropdown(item.catalogId)" 
                            v-on:click="changeItem({type: 4, dataChild: item})"
                        >{{item.catalogName}}<span v-if="checkHaveChild">&#9206;</span><span v-else>&#9207;</span>
                        </p>
                        <ul class="list-child"  v-for="(subItem, index) in listCatalog" :key="index"   :class="[{active: activeID==subItem.catalogId}]">
                            <template v-if="checkChild == subItem.parentId && checkClick" >
                                <li v-if="item.catalogId == subItem.parentId"  v-on:click="changeItem({type: 4, dataChild: subItem})">
                                    <p >{{ subItem.catalogName }}</p>
                                </li>
                            </template>
                        </ul> 

                    </li>
                </ul>
            </template>
        </div>
    </div>
</template>

<script>
export default {
  data() {
    return {
      activeID: null,
      listCatalog: [],
      checkType: 0,
      toogle: false,
      checkChild: null,
      checkClick: false,
      checkHaveChild: false
    };
  },
  props: {
    data: {
      type: Object,
      default: {}
    }
  },
  created() {
    if (!this.data.dataLeftSeflCourse) return;
    this.listCatalog = this.data.dataLeftSeflCourse.listCatalog;
    this.listCatalog = this.listCatalog.sort(
      (a, b) => parseFloat(a.order) - parseFloat(b.order)
    );
    this.init();
  },
  methods: {
    /// Hiển thị menu
    init: function() {
      if (this.data.dataBegin == null) {
        this.activeID = "0cs";
      } else {
        if (this.data.dataBegin.type != "4cs") {
          this.activeID = this.data.dataBegin.type;
        } else {
          this.activeID = this.data.dataBegin.catalogId;
        }
      }
      this.toogle = this.data.setClick;
    },
    /// click thay đổi nội dung khoá học
    changeItem: function(value) {
      this.$api.post("/home/getLoginFlagUser", {
                'loginName': window.sessionStorage.getItem('loginName'),
                'companyId': window.sessionStorage.getItem('companyId')
            }).then(response => {
              if (response.meta.success) {
                this.$emit("changeItem", value);
                this.checkType = value.type;
                let id = null;
                if (value.type == 4) {
                  id = value.dataChild.catalogId;
                } else {
                  id = value.dataChild.id;
                }
                this.activeID = id;
                document.getElementsByTagName("body")[0].classList.remove("show-menu-1");
              }
      })
    },
    checkToogle() {
      this.toogle = !this.toogle;
    },
    // checkArows(){
    //      for (let i = 0; i < this.listCatalog.length; i++) {
    //         for (let j = 0; j < this.listCatalog.length; j++) {
    //             if(this.listCatalog[i].catalogId == this.listCatalog[j].parentId){
    //                 this.checkHaveChild = !this.checkHaveChild;
    //             }
    //         }
    //      }
    // },
    hamDropdown(item) {
      this.checkChild = item;
      this.checkClick = !this.checkClick;
      for (let index = 0; index < this.listCatalog.length; index++) {
        if (item == this.listCatalog[index].parentId) {
          this.checkHaveChild = !this.checkHaveChild;
        }
      }
    }
  }
};
</script>
<style scoped>
.manage--left {
  overflow: auto;
}
.nqt--list--lessons {
  cursor: pointer;
  color: #0071c1 !important;
  padding: 0;
}
.title_lesson_dad {
  font-size: 16px;
  display: flex;
  font-weight: 400px;
  color: #000;
  justify-content: space-between;
}
.title_lesson_chid {
  color: #0071c1;
}
.nqt--list--lessons:hover {
  background-color: #f3f3f3;
}
.list--lessons--default {
  padding: 10px 0;
}
.div-list-lessons ul {
  color: #0071c5;
  list-style: none;
  margin: 0px;
  padding-left: 0;
}
.div-list-lessons .list-parentId {
  display: flex;
  flex-direction: column;
  width: 100%;
  color: rgb(0, 0, 0);
  float: left;
  /* position: relative; */
  text-decoration: none;
}
.div-list-lessons .list-parentId p {
    padding: 10px 10px;
    display: flex !important;
    align-items: center;
    flex-direction: row;
    border-bottom: 1px solid #0071c5;
    justify-content: space-between;
}

/* .div-list-lessons .list-parentId:hover {
    cursor: pointer;
} */
.div-list-lessons .nqt--list--lessons .list-parentId .list-child {
  padding-left: 30px;
  min-width: 5rem;
  /* position: absolute; */
  left: 0;
  z-index: 1;
  color: #717171;
  /* display: none; */
}
.div-list-lessons .nqt--list--lessons .list-parentId .list-child li {
  display: flex;
  column-gap: 5px;
  padding: 10px 10px;
  border-bottom: 1px solid #c1bcbc;
}
.div-list-lessons .nqt--list--lessons .list-parentId .list-child li:last-child {
  border: none;
}
.div-list-lessons .nqt--list--lessons .list-parentId .list-child p {
  padding: 0;
  overflow-wrap: anywhere;
  border: none;
}
/* .div-list-lessons .nqt--list--lessons .list-parentId:hover > .list-child,
.div-list-lessons .nqt--list--lessons .list-parentId .list-child:hover {
    display: block;
} */
.list--lessons--curriculum {
  font-size: 15px;
  margin: 1px 0;
  position: relative;
  cursor: pointer;
}
.nqt--list--lessons.active {
  color: #0071c5;
}
.nqt--list--lessons.active {
  color: #000;
}
.active {
  transition: all 0.5s ease;
  color: #fff !important;
  font-weight: bold;
  background: #0071c5 !important;
  display: block !important;
  border-radius: 5px;
  margin-bottom: 2px !important;
}
.active li {
  border: none !important;
}
.active:hover {
  background: #0071c5;
}
.nqt--list--lessons.active p {
  color: #ffffff;
}
.div-list-lessons {
  background: #f5f5f5;
}
</style>



// WEBPACK FOOTER //
// src/components/defineSelfCourse/content/leftSelfCourse.vue